import React from 'react'
import FloatContainer from '../../Wrappers/FloatContainer'
import DropdownItem from '../../Atoms/Items/DropdownItem'
import Icon from '../../Atoms/Icon'

const PayrollSelect = () => {
  return (
    <div className="s-relative">
      <FloatContainer>
        <h3 className="hover-change s-px-8px normal-radius cursor-pointer s-cross-center m-ml-4px s-mb-0">
          <span className="s-mr-8px">Periodo quincenal del 1 al 15</span>
          <Icon svg="down" size="1rem" />
        </h3>
        <div className="float-container">
          <DropdownItem text="Periodo quicenal del 1 al 15" isActive />
          <DropdownItem text="Periodo quicenal del 15 al 31" />
          <DropdownItem text="Periodo mensual del 1 al 31" />
          <DropdownItem text="Todos los Periodos" />
        </div>
      </FloatContainer>
    </div>
  )
}

export default PayrollSelect
